export const featureIdToFilterAlias = {
  CampaignsGrid: {
    newCampaign: campaignName => ([{
      SelectedColumn: 'CampaignName',
      SelectedOperator: 'Contains',
      Values: [campaignName],
    }]),
  },
};
